<template>
  <v-app :class="{'mobile-app': isMobileApp}">
  	<v-progress-linear :indeterminate="true" height="4" v-if="isLoading"></v-progress-linear>
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>
    <v-snackbar :timeout="snackbar.timeout" :bottom="true" v-model="snackbar.status" :color="snackbar.color">
	    {{ snackbar.message }}
    </v-snackbar>
  </v-app>
</template>

<script>

  export default {
    data () {
      return {
        
      }
    },
    computed: {
      isLoading: function(){
        return this.$store.getters.isLoading
      },
      snackbar: function(){
        return this.$store.getters.snackbar
      }
    }
  }
</script>

<style scoped>
	.v-progress-linear {
		margin: 0;
		position: fixed;
		top: 0;
		left: 0;
	}
</style>
